import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { userIdSelector, eventFormSelector, flyerSelector } from 'src/selectors'
import Button from 'src/components/common/Button'
import PropTypes from 'prop-types'
import RightIconWhite from 'src/assets/icons/right-icon-white.png'
import CloseIconGray from 'src/assets/icons/close-icon-gray.png'
import FlyerCard from './FlyerCard/FlyerCard'
import VideoFlyerCard from './VideoFlyerCard/VideoFlyerCard'
import CustomFlyerPicker from './CustomFlyerPicker/CustomFlyerPicker'
import { clearCustomFlyerURL } from 'src/actions/flyer'
import { isSmallScreen } from 'src/actions/utils'
import SvgIcon from 'src/components/common/SvgIcon'
import UploadIcon from 'src/assets/icons/icon-upload.svg'
import cn from 'classnames'
import styles from './select-flyer-step.scss'
import { changeEventForm } from 'src/actions/event'

const SelectFlyerStep = ({ type = 'create', onButtonClick, onClickBack }) => {
  const dispatch = useDispatch()

  const userId = useSelector(userIdSelector)
  const eventForm = useSelector(eventFormSelector)
  const { customFlyerURL, flyerList } = useSelector(flyerSelector)
  const flyerCardRefs = useRef([])

  const [activeFlyerList, setActiveFlyerList] = useState([])

  const handleButtonClick = () => {
    if (type === 'create') {
      const index = activeFlyerList.findIndex(
        item => item.design_number === eventForm.flyer_design_number
      )

      const selectedItem = activeFlyerList.find(
        item => item.design_number === eventForm.flyer_design_number
      )

      if (selectedItem?.video_bg_slug) {
        flyerCardRefs.current[index]?.generateImage().then((blob) => {
          const imageFile = new File([blob], 'video-flyer-image.png', { type: 'image/png' })
          dispatch(changeEventForm({ checkedFlyer: imageFile }))
          onButtonClick()
        })
      } else if (selectedItem?.image_bg_slug) {
        flyerCardRefs.current[index]?.onCanvasToImage().then((imgFile) => {
          const imageFile = new File([imgFile], 'flyer-image.png', { type: 'image/png' })
          dispatch(changeEventForm({ checkedFlyer: imageFile }))
          onButtonClick()
        })
      }
      window.mixpanel.track('SAVE DESIGN Clicked', { user_id: userId })
    }

    if (type === 'edit') {
      onButtonClick()
    }
  }

  useEffect(() => {
    const filterFlyerList = flyerList.filter(item => (item.video_bg_slug || item.image_bg_slug))

    if (customFlyerURL) {
      filterFlyerList.unshift({ design_number: '8', design_slug: 'hobnob:custom' })
    }

    setActiveFlyerList(filterFlyerList)
  }, [flyerList, customFlyerURL])

  let flyerNodes = activeFlyerList.map((item, index) => {
    if (item.video_bg_slug) {
      return (
        <VideoFlyerCard
          flyerDetail={item}
          key={item.design_number}
          ref={ref => (flyerCardRefs.current[index] = ref)}
        />
      )
    } else if (item.image_bg_slug) {
      return (
        <FlyerCard
          flyerDetail={item}
          key={item.design_number}
          ref={ref => (flyerCardRefs.current[index] = ref)}
        />
      )
    }
  })

  if (isSmallScreen) {
    flyerNodes.splice(2, 0,
      <div className={styles['flyer-wrapper-mobile']} key="custom-flyer-mobile">
        <CustomFlyerPicker >
          <section className={styles['flyer-wrapper-mobile-section-container']}>
            <SvgIcon icon={UploadIcon} width={24} height={24} />
            <p className={styles['tip']}>Use your own flyer design</p>
          </section>
        </CustomFlyerPicker>
      </div>
    )
  }

  return (
    <div className={styles['selected-flyer-step-container']}>
      <div className={styles['image-view']}>
        <div className={styles['image-wrapper']}>
          <div className={styles['flyer-wrapper']}>
            <CustomFlyerPicker />
          </div>

          {flyerNodes}
        </div>
      </div>
      <div className={styles['button-wrapper']}>
        {customFlyerURL && (
          <Button
            className={styles['remove-image-button']}
            purple
            onClick={() => dispatch(clearCustomFlyerURL())}
          >
            <img src={CloseIconGray} alt="" width="16" />
            <span>Remove Image</span>
          </Button>
        )}
        {
          type === 'edit' && (
            <Button
              className={cn(styles['button-inner'], styles['cancel-button'])}
              onClick={onClickBack}
              filled={false}
            >
              <span>Cancel</span>
            </Button>
          )
        }
        <Button
          className={cn(styles['button-inner'], type === 'edit' && styles['save-button'])}
          onClick={handleButtonClick}
          disabled={!eventForm.flyer_design_number}
        >
          <span>{type === 'create' ? 'SAVE DESIGN' : 'Save'}</span>
          {
            type === 'create' && (
              <img src={RightIconWhite} alt="" width="24" />
            )
          }
        </Button>
      </div>
    </div>
  )
}

SelectFlyerStep.propTypes = {
  type: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClickBack: PropTypes.func
}

export default SelectFlyerStep
